import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CommonCloudStudioModule, ENVIRONMENT, } from 'common-cloudstudio';
import { IncidentService } from '../services/incident.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../../shared/shared.module';
import { IncidentContactGroupsComponent } from './incident-contact-groups/incident-contact-groups.component';
import { IncidentFormComponent } from './incident-form.component';
import { AgmCoreModule } from '@agm/core';
import { incidentFormRoutes } from './incident-form.routes';
import { IncidentSharedModule } from '../incident-shared/incident-shared.module';

declare var environment;

export function environmentFactory(): any {
  return environment;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['drawing', 'places', 'geometry']
    }),
    incidentFormRoutes,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    BsDropdownModule,
    SharedModule,
    IncidentSharedModule
  ],
  exports: [IncidentFormComponent],
  declarations: [
    IncidentFormComponent,
    IncidentContactGroupsComponent,
  ],
  providers: [IncidentService, { provide: ENVIRONMENT, useFactory: environmentFactory },],

})
export class IncidentFormModule { }
